import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Icon, Modal, Button } from 'grab-ui';

import { clearErrorModalAction } from 'actions/app-actions';

import css from './error-modal.less';

export const ERROR_MODAL_TYPE = {
  WARNING: 'WARNING', // default
  FAILED: 'FAILED',
};

const MODAL_OPEN_STATE = {
  closed: 0,
  open: 1,
  closing: 2,
};

class ErrorModal extends Component {
  static getDerivedStateFromProps(props, state) {
    if (!_isEmpty(props.errorModal)) {
      // message and description stored in state because we want to continue showing the message while the animation hides the modal
      if (state.openState === MODAL_OPEN_STATE.open) {
        // Update error message
        return {
          message: props.errorModal.message,
          description: props.errorModal.description,
          okButtonText: props.errorModal.okButtonText,
          extraButtonText: props.errorModal.extraButtonText,
        };
      }

      // No state change if message and description remains the same. Because errorModal is only cleared after setting openState
      if (
        state.openState === MODAL_OPEN_STATE.closing &&
        state.message === props.errorModal.message &&
        state.description === props.errorModal.description
      ) {
        return null;
      }

      // Open modal and update error message
      return {
        openState: MODAL_OPEN_STATE.open,
        message: props.errorModal.message,
        description: props.errorModal.description,
        okButtonText: props.errorModal.okButtonText,
        extraButtonText: props.errorModal.extraButtonText,
      };
    }

    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      openState: MODAL_OPEN_STATE.closed,
      message: '',
      description: '',
    };
  }

  onClickOk = () => {
    const { clearErrorModal } = this.props;
    const { errorModal: { onOk } } = this.props;

    this.setState(
      {
        openState: MODAL_OPEN_STATE.closing,
      },
      () => {
        clearErrorModal();
        if (typeof onOk === 'function') {
          onOk();
        }
        setTimeout(() => {
          if (this.state.openState === MODAL_OPEN_STATE.closing) {
            // Clear message and description if it is still closed
            this.setState({
              openState: MODAL_OPEN_STATE.closed,
              message: '',
              description: '',
            });
          }
        }, 500);
      },
    );
  };

  onClickExtra = () => {
    const { clearErrorModal } = this.props;
    const { errorModal: { onExtraButton } } = this.props;
    this.setState(
      {
        openState: MODAL_OPEN_STATE.closing,
      },
      () => {
        clearErrorModal();
        if (typeof onExtraButton === 'function') {
          onExtraButton();
        }
      },
    );
  };

  getIcon = () => {
    const { errorModal: { type } } = this.props;

    return {
      [ERROR_MODAL_TYPE.WARNING]: (
        <Icon
          type="exclamation-circle"
          theme="filled"
          style={{ color: '#F7C942' }}
        />
      ),
      [ERROR_MODAL_TYPE.FAILED]: (
        <Icon type="close-circle" theme="filled" style={{ color: '#EE6352' }} />
      ),
    }[type || ERROR_MODAL_TYPE.WARNING];
  };

  render() {
    const {
      openState,
      message,
      description,
      okButtonText,
      extraButtonText,
    } = this.state;

    return (
      <Modal
        visible={openState === MODAL_OPEN_STATE.open}
        className={css.errorModal}
        footer={null}
      >
        <div className={css.modalBody}>
          <div className={css.content}>
            {this.getIcon()}
            <div>
              <h5>{message}</h5>
              <h6>{description}</h6>
            </div>
          </div>
          <div className={css.buttonWrapper}>
            <Button onClick={this.onClickOk}>
              {okButtonText || I18n.t('v2.commonButton.ok')}
            </Button>
            {extraButtonText && (
              <Button onClick={this.onClickExtra} className={css.greenButton}>
                {extraButtonText}
              </Button>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

ErrorModal.propTypes = {
  errorModal: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
    description: PropTypes.string,
    okButtonText: PropTypes.string,
  }),
  clearErrorModal: PropTypes.func.isRequired,
};

ErrorModal.defaultProps = {
  errorModal: {},
};

const mapStateToProps = state => ({
  errorModal: state.app.errorModal,
});

const mapDispatchToProps = {
  clearErrorModal: clearErrorModalAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
